function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3851 363C3845.5 125.7 3678 .1 3472.1.1c-113.1 0-214.6 37.9-284 111.4C3118.7 37.9 3017.2 0 2904.2 0c-206 0-373.6 125.8-378.9 363.4a8.08 8.08 0 00-.1 1.6v541a90 90 0 0090 90h85a15 15 0 0015-15V365h.1c3.6-117 86.8-179 188.9-179s185.3 62 188.9 179h.1v541a90 90 0 0090 90h85a15 15 0 0015-15V365h.1c3.6-117 86.8-179 188.9-179s185.3 62 188.9 179h.1v541a90 90 0 0090 90h85a15 15 0 0015-15V365a12.31 12.31 0 00-.2-2z"
});

function SvgHboMax(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2480 0 1420 1000"
  }, props), _ref);
}

export default SvgHboMax;